export const uploadTestReport = (payload?: any) => ({
    type: "@saga/UPLOAD_TEST_REPORT",
    payload
});

